import React, { useState } from "react";

import {
  Wallet,
  Landmark,
  ArrowLeft,
  ShieldCheck,
  Send,
  Users,
  BadgeDollarSign,
  Smartphone,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";

import "../Styles/MMG.css";

import SubscriberFormModal from "../components/SubscriberFormModal";

import { useNavigate } from "react-router-dom";

const MMG = () => {

  const [showSubscriberForm,
    setShowSubscriberForm] =
      useState(false);

  const navigate =
    useNavigate();

  const services = [

    "Wallet Recharge",

    "Wallet Withdrawal",

    "Agent Transfers",

    "Agent Vending",

    "Receiving For Non-Account Holders",

  ];

  return (

    <div className="modern-mmg-page">

      {/* HERO */}
      <section className="modern-mmg-hero">

        <div className="modern-mmg-overlay" />

        <div className="modern-mmg-content">

          <button
            className="modern-mmg-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-mmg-badge">
            MMG+ SERVICES
          </div>

          <h1 className="modern-mmg-heading">
            Fast.
            <br />
            Secure.
            <br />
            <span>Reliable Transactions.</span>
          </h1>

          <p className="modern-mmg-text">
            RCS is the only MMG+
            Superagent on Wakenaam,
            delivering convenient subscriber
            services, agent transfers and
            digital payment solutions.
          </p>

        </div>

      </section>

      {/* HIGHLIGHTS */}
      <section className="modern-mmg-highlights">

        <div className="modern-mmg-highlight-card">

          <div className="modern-mmg-icon">
            <Wallet size={34} />
          </div>

          <h3>
            Subscriber Services
          </h3>

          <p>
            Deposits, withdrawals and
            wallet management services.
          </p>

        </div>

        <div className="modern-mmg-highlight-card">

          <div className="modern-mmg-icon">
            <Landmark size={34} />
          </div>

          <h3>
            Agent Transfers
          </h3>

          <p>
            Fast and reliable MMG+
            transfers and vending.
          </p>

        </div>

        <div className="modern-mmg-highlight-card">

          <div className="modern-mmg-icon">
            <ShieldCheck size={34} />
          </div>

          <h3>
            Secure Transactions
          </h3>

          <p>
            Trusted financial services
            with professional support.
          </p>

        </div>

      </section>

      {/* MAIN CONTENT */}
      <section className="modern-mmg-main">

        {/* SERVICES */}
        <div className="modern-mmg-card">

          <div className="modern-mmg-card-header">

            <div className="modern-mmg-header-icon">
              <BadgeDollarSign size={30} />
            </div>

            <div>

              <h2>
                Transaction Types
              </h2>

              <p>
                Services offered by RCS.
              </p>

            </div>

          </div>

          <div className="modern-mmg-services-list">

            {services.map(
              (service, index) => (

              <div
                className="modern-mmg-service-item"
                key={index}
              >

                <CheckCircle2
                  size={18}
                />

                {service}

              </div>
            ))}

          </div>

          <div className="modern-mmg-note">

            <h3>
              Receiving For Non-MMG
              Account Holders?
            </h3>

            <p>
              Simply provide the sender
              with the following details:
            </p>

            <div className="modern-mmg-accounts">

              <div className="modern-mmg-account">

                <Smartphone size={18} />

                RUPESH COYSILRAM- SUBSCRIBER
                +592 702 4443

              </div>

              <div className="modern-mmg-account">

                <Smartphone size={18} />

                RCS TOPUP & BILLING ENTITY- MERCHANT
                +592 662 7987

              </div>

            </div>

          </div>

        </div>

        {/* SIGNUP */}
        <div className="modern-mmg-card">

          <div className="modern-mmg-card-header">

            <div className="modern-mmg-header-icon green">
              <Users size={30} />
            </div>

            <div>

              <h2>
                MMG+ Sign Up
              </h2>

              <p>
                Become an agent or subscriber.
              </p>

            </div>

          </div>

          <p className="modern-mmg-signup-text">

            Want to become a registered
            MMG+ Agent or subscriber?
            Complete the sign-up process
            to start receiving and sending
            funds or increase your
            customer foot traffic.

          </p>

          <div className="modern-mmg-button-stack">

            <a
              href="https://www.mmg.gy/lead-generation/"
              target="_blank"
              rel="noopener noreferrer"
              className="modern-agent-btn"
            >

              <Landmark size={18} />

              Become An Agent

            </a>

            <button
              className="modern-subscriber-btn"
              onClick={() =>
                setShowSubscriberForm(true)
              }
            >

              <Send size={18} />

              Become A Subscriber

              <ArrowRight size={18} />

            </button>

          </div>

        </div>

      </section>

      {showSubscriberForm && (

        <SubscriberFormModal
          onClose={() =>
            setShowSubscriberForm(false)
          }
        />
      )}

    </div>
  );
};

export default MMG;